import styled from '@emotion/styled'
import { isNil, curry, defaultTo } from 'ramda'

const withStyle = (BitGrid) =>
  styled(BitGrid)(
    () => `
        margin-top: 1em;
      `
  )

export default withStyle

const findColor = curry(
  (defaultColor, colors, props, btnStatesByPrecedence) => {
    const firstTrueProp = btnStatesByPrecedence.find((prop) => props[prop])
    return defaultTo(defaultColor, colors[firstTrueProp])
  }
)

const statePrecedence = ['occupied', 'hovered', 'selected', 'disabled']

export const StyledBit = styled.div((props) => {
  const { disabled, theme, isEditing } = props
  const { blueSecondary, blueAvailable } = theme.color

  const {
    buttonPrimaryColor,
    btnDisabledColor,
    btnDisabledBg,
    btnPrimaryHoverBg,
    btnPrimaryFocusBg,
    btnOnColorLightColor,
  } = theme

  const bitBgColors = {
    disabled: btnDisabledBg,
    hovered: btnPrimaryHoverBg,
    selected: btnPrimaryFocusBg,
    occupied: btnDisabledColor,
  }

  const bitTextColors = {
    disabled: btnDisabledColor,
    hovered: buttonPrimaryColor,
    selected: buttonPrimaryColor,
    occupied: btnOnColorLightColor,
  }

  const background = (() => {
    const findBgColor = findColor(blueAvailable, bitBgColors, props)

    return findBgColor(statePrecedence)
  })()

  const color = (() => {
    const findTextColor = findColor(blueSecondary, bitTextColors, props)

    return findTextColor(statePrecedence)
  })()

  return `
    background: ${background};
    color: ${color};
    width: 12.5%;
    text-align: center;
    border-radius: 5px;
    border: 1px solid ${buttonPrimaryColor}; // to simulate margin but retain hoverability
    cursor: ${disabled ? 'not-allowed' : 'pointer'}; 
    font-weight: bold;
    pointer-events: ${isEditing ? 'auto' : 'none'};
  `
})

export const StyledByteLabel = styled.div`
  margin-top: 1px;
  margin-bottom: 1px;
  margin-right: 10px;
  font-weight: bold;
`

export const StyledSelectionValue = styled.div((props) => {
  const { errorPrimary } = props.theme.color

  return `
    color: ${isNil(props.value) ? errorPrimary : 'inherit'}
  `
})
